module.exports = __webpack_public_path__ + "static/promo-text-3a70153c01e4e8c018fe90f791df640c.svg";